// extracted by mini-css-extract-plugin
export default {"profile":"styles_profile__PHdqM","heading":"styles_heading__pTQnO"};